<template>
  <div class='EnbClients'>
    <div class="header">
      <client-action/>
      <clients-header/>
    </div>
    <enb-vazio
    v-if="!Clients.length && !GlobalLoading"
    text="Nenhum registro encontrado!"
    />
    <div class="cont" @scroll="run">
      <clients-list
      v-for="(c, key) in Clients"
      :key="key"
      :data="c"
      :chave="key"
      />
      <div class="bottom">
        <vue-spinner v-if="load" size="45"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ClientsHeader from './Header/ClientsHeader'
import ClientAction from './Header/ClientAction'
import ClientsList from './Itens/ClientsList'
import { VueSpinner } from 'vue3-spinners'
import EnbVazio from '../EnbVazio'
export default {
  name: 'EnbClients',
  components: { ClientsHeader, ClientAction, ClientsList, VueSpinner, EnbVazio },
  data () {
    return {
      scroll: {
        position: 0,
        height: 1
      },
     load: false
    }
  },
  computed: {
    ...mapGetters(['Clients', 'GlobalLoading'])
  },
  methods: {
    ...mapActions(['GetClient', 'Loading']),
    run (e) {
      this.scroll = {
        position: (e.target.offsetHeight + e.target.scrollTop),
        height: e.target.scrollHeight
      }
      if((this.scroll.height - this.scroll.position) <= 1) {
        //busca
        this.load = true
        setTimeout(() => {
          this.GetClient({
            params: { 
              last: this.Clients[this.Clients.length - 1].usuario.id,
              limit: 5
            },
            init: false
          })
          .then(() => {
            this.load = false
          })
        }, 2000)
      }
    }
  },
  created () {
    this.Loading(true)
    this.GetClient({
      params: { last: 0, limit: 10 }, init: true
    })
    .then(() => {
      this.Loading(false)
    })
  }
}
</script>

<style scoped>
.EnbClients {
  width: 100%;
  height: 100%;
}

.cont {
  width: 98%;
  height: 88%;
  padding: 1%;
  padding-top: 0;
  padding-bottom: 0;
  overflow: auto;
}

.bottom {
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 500px) {
  .cont {
    height: 60%;
  }
}
</style>
